var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumanResourcesSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#26BEBE"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A49A"
    },
    d: "M305.978,507.109c101.292-20.047,181.086-99.842,201.132-201.133L376.68,175.547l-23.571,6.896 l-68.663-68.665L133.051,256.595l-19.272,27.85l70.721,70.722l-8.952,21.514L305.978,507.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M398.224,284.444v-56.889h-32.028c-2.686-10.438-6.839-20.282-12.186-29.336l22.673-22.673 l-40.227-40.227l-22.673,22.673c-9.052-5.349-18.897-9.5-29.336-12.186v-32.028h-56.889v32.028 c-10.438,2.686-20.282,6.839-29.336,12.186l-22.673-22.673l-40.227,40.226l22.673,22.673c-5.349,9.052-9.5,18.897-12.186,29.336 h-32.028v56.889h32.028c2.686,10.438,6.839,20.282,12.186,29.336l-22.673,22.673l40.226,40.227l22.673-22.673 c9.052,5.349,18.897,9.5,29.336,12.186v32.03h56.889v-32.028c10.438-2.686,20.282-6.837,29.336-12.186l22.673,22.673l40.226-40.226 l-22.673-22.673c5.349-9.052,9.5-18.897,12.186-29.336h32.032V284.444z M256.002,312.889c-31.418,0-56.889-25.471-56.889-56.889 s25.471-56.889,56.889-56.889s56.889,25.471,56.889,56.889S287.42,312.889,256.002,312.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M398.224,284.444v-56.889h-32.028c-2.686-10.438-6.839-20.282-12.186-29.336l22.673-22.673 l-40.227-40.227l-22.673,22.673c-9.052-5.349-18.897-9.5-29.336-12.186v-32.028h-28.444v85.333 c31.418,0,56.889,25.471,56.889,56.889s-25.471,56.889-56.889,56.889v85.333h28.444v-32.028 c10.438-2.686,20.282-6.837,29.336-12.186l22.673,22.673l40.226-40.226l-22.673-22.673c5.349-9.052,9.5-18.897,12.186-29.336h32.03 V284.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5F1F4"
    },
    d: "M256.002,347.367c-50.381,0-91.367-40.986-91.367-91.367s40.986-91.367,91.367-91.367 s91.367,40.986,91.367,91.367S306.381,347.367,256.002,347.367z M256.002,176.7c-43.725,0-79.3,35.575-79.3,79.3 s35.575,79.3,79.3,79.3s79.3-35.575,79.3-79.3S299.727,176.7,256.002,176.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M347.369,256c0-50.379-40.986-91.367-91.367-91.367V176.7c43.725,0,79.3,35.575,79.3,79.3 s-35.575,79.3-79.3,79.3v12.067C306.381,347.367,347.369,306.381,347.369,256z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 256,
    r: 80.396
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9EFF4"
    },
    d: "M336.398,256c0-44.401-35.995-80.396-80.396-80.396v160.794 C300.403,336.396,336.398,300.401,336.398,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.599,296.507h-89.197V281.39c0-10.745,6.877-20.285,17.07-23.683l16.379-5.46h22.299l16.379,5.46 c10.193,3.398,17.07,12.938,17.07,23.683V296.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8C9D9"
    },
    d: "M300.599,281.39c0-10.745-6.877-20.285-17.07-23.683l-16.379-5.46h-11.724v44.26h45.171V281.39 H300.599z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FED8B2"
    },
    points: "267.15,252.247 256.002,263.396 244.852,252.247 244.852,241.097 267.15,241.097 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFC095"
    },
    points: "255.426,241.097 255.426,262.822 256.002,263.396 267.15,252.247 267.15,241.097 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E3C3"
    },
    d: "M233.701,218.798c0-12.316,9.983-22.299,22.299-22.299s22.299,9.983,22.299,22.299 c0,12.316-9.983,33.449-22.299,33.449S233.701,231.114,233.701,218.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED8B2"
    },
    d: "M256.002,196.499c-0.193,0-0.381,0.024-0.574,0.029v55.687c0.191,0.01,0.381,0.031,0.574,0.031 c12.316,0,22.299-21.133,22.299-33.449C278.3,206.483,268.316,196.499,256.002,196.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444"
    },
    d: "M278.3,218.798c0-12.316-9.983-22.299-22.299-22.299s-22.299,9.983-22.299,22.299 c0,4.915,1.593,11.231,4.287,17.051c-0.631-3.35-0.462-6.775-0.131-9.359c14.155-1.11,27.814-7.732,27.814-7.732 s1.729,3.177,8.213,6.004c0.459,2.638,0.914,6.927,0.124,11.099C276.704,230.038,278.3,223.716,278.3,218.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M278.3,218.798c0-12.316-9.983-22.299-22.299-22.299c-0.193,0-0.381,0.024-0.574,0.029v26.229 c6.089-1.991,10.243-3.999,10.243-3.999s1.729,3.177,8.213,6.004c0.459,2.638,0.914,6.927,0.124,11.099 C276.704,230.038,278.3,223.715,278.3,218.798z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9B54C"
    },
    points: "251.313,296.117 254.438,267.107 257.564,267.107 260.689,296.117 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4A200"
    },
    points: "257.564,267.107 255.426,267.107 255.426,296.117 260.689,296.117 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M239.75,253.947l-11.278,3.76c-10.193,3.398-17.07,12.938-17.07,23.683v15.117h44.023v-1.879 L239.75,253.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M300.599,281.39c0-10.745-6.877-20.285-17.07-23.683l-11.278-3.76L256,296.117l-0.574-1.489v1.879 h45.171V281.39H300.599z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F2D3A"
    },
    points: "272.251,253.947 275.34,267.107 269.479,270.038 275.34,276.778 256,296.117 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B3B4E"
    },
    points: "239.75,253.947 236.661,267.107 242.521,270.038 236.661,276.778 256,296.117 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4A200"
    },
    points: "262.154,263.446 258.051,273.115 253.949,273.115 249.847,263.446 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC8200"
    },
    points: "262.154,263.446 255.426,263.446 255.426,273.115 258.051,273.115 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFDBE6"
    },
    points: "265.671,267.107 272.251,253.947 267.15,252.247 256.002,263.396 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9EFF4"
    },
    points: "246.331,267.107 239.75,253.947 244.852,252.247 256,263.396 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanResourcesSvgrepoCom);
export default __webpack_public_path__ + "static/media/human-resources-svgrepo-com.364bd4040f898957c01db1defcda80bd.svg";
export { ForwardRef as ReactComponent };